import * as pdfjsLib from "pdfjs-dist/build/pdf";

const configurePdfjs = () => {
  const workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;
  pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;
};

export const getDocument = pdfjsLib.getDocument;
export const GlobalWorkerOptions = pdfjsLib.GlobalWorkerOptions;
export default configurePdfjs;
